import { CustomFieldDefinitionValidationType } from "@tfg/types/schemas/customField"

import { CustomFieldsForm } from "./CustomFieldsForm"

interface Props {
  close: () => void
  customField: CustomFieldDefinitionValidationType
}

export const CustomFieldsUpdateForm = ({ customField, close }: Props) => {
  return <CustomFieldsForm customField={customField} close={close} />
}
